export const blockIconsCommunicationContactsNew = (
	<span className='material-symbols-outlined'>contacts</span>
);
